<template>
  <div class="panel-item">
    <div class="title_name" style="display: flex; justify-content: space-between;">
      <div>出单产品增长情况</div>
    </div>
    <div ref="chartContainer" class="chart-container"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  components: {},
  props: {
    name: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      // 初始化图表
      this.chart = echarts.init(this.$refs.chartContainer);

      // 统一数据处理方式
      const xAxisData = this.datas && this.datas.length > 0
          ? this.datas.map(item => `${item.month}月`)
          : ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];

      const seriesData = this.datas && this.datas.length > 0
          ? this.datas.map(item => item.product_count || 0)
          : [];

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          top: '4%',
          left: '6%',
          right: '6%',
          bottom: '6%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              color: '#fff',
              // 设置标签间隔，确保首尾显示，并根据宽度自适应显示中间部分
              interval: (index, value) => {
                // 始终显示第一个和最后一个
                if (index === 0 || index === xAxisData.length - 1) {
                  return true;
                }

                // 当容器宽度极小时，确保至少显示首尾两个标签
                const containerWidth = this.$refs.chartContainer.offsetWidth;
                if (containerWidth < 200) {
                  // 极小宽度下只显示首尾标签
                  return false;
                }

                // 根据容器宽度和标签数量计算间隔
                const labelCount = xAxisData.length;
                const maxLabels = Math.floor(containerWidth / 60);

                if (labelCount <= maxLabels) {
                  return true;
                }

                const interval = Math.ceil(labelCount / maxLabels);

                // 特殊处理：确保倒数第二个不会因为取余计算而排除最后一个
                if (index % interval === 0) {
                  return true;
                }

                // 再次确保最后一个标签显示
                if (index === xAxisData.length - 1) {
                  return true;
                }

                return false;
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#fff'
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,0.2)'
              }
            }
          }
        ],
        series: [
          {
            name: '产品数',
            type: 'bar',
            barWidth: '60%',
            data: seriesData,
            itemStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  {offset: 0, color: '#2A76D5'},
                  {offset: 1, color: '#5AC1FF'}
                ]
              }
            }
          }
        ]
      };

      // 设置图表配置
      this.chart.setOption(option);

      // 监听窗口大小变化
      window.addEventListener('resize', this.handleResize);
    },

    handleResize() {
      if (this.chart) {
        this.chart.resize();
        // 重新设置选项以触发interval函数重新计算
        this.updateChart();
      }
    },

    // 根据传入的数据更新图表
    updateChart() {
      if (!this.chart || !this.datas.length) return;

      // 统一数据处理方式，与initChart保持一致
      const xAxisData = this.datas.map(item => `${item.month}月`);
      const seriesData = this.datas.map(item => item.product_count);

      const option = {
        xAxis: {
          data: xAxisData,
          axisLabel: {
            interval: (index, value) => {
              // 始终显示第一个和最后一个
              if (index === 0 || index === xAxisData.length - 1) {
                return true;
              }

              // 当容器宽度极小时，确保至少显示首尾两个标签
              const containerWidth = this.$refs.chartContainer.offsetWidth;
              if (containerWidth < 200) {
                // 极小宽度下只显示首尾标签
                return false;
              }

              // 根据容器宽度和标签数量计算间隔
              const labelCount = xAxisData.length;
              const maxLabels = Math.floor(containerWidth / 60);

              if (labelCount <= maxLabels) {
                return true;
              }

              const interval = Math.ceil(labelCount / maxLabels);

              // 特殊处理：确保倒数第二个不会因为取余计算而排除最后一个
              if (index % interval === 0) {
                return true;
              }

              // 再次确保最后一个标签显示
              if (index === xAxisData.length - 1) {
                return true;
              }

              return false;
            }
          }
        },
        series: [{
          data: seriesData
        }]
      };

      this.chart.setOption(option);
    }
  },

  watch: {
    datas: {
      handler() {
        this.updateChart();
      },
      deep: true
    }
  },

  beforeDestroy() {
    // 销毁图表实例
    if (this.chart) {
      this.chart.dispose();
      window.removeEventListener('resize', this.handleResize);
    }
  }
}
</script>

<style lang="scss" scoped>
.title_name {
  padding: 30px 0 23px 100px;
  font-weight: 400;
  font-size: 22px;
  color: #FFFFFF;
}

.panel-item {
  width: 490px;
  height: 420px;
  background: url(../../../../assets/_s-image_sector_bg.png) no-repeat;
  background-size: 100% 100%;
}

.chart-container {
  width: 100%;
  height: calc(100% - 85px);
}
</style>
